import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBBtn,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
} from "mdb-react-ui-kit";
import {
  FaUserAlt,
  FaLock,
  FaHistory,
  FaFileAlt,
  FaBox,
  FaSignOutAlt,
  FaGift,
  FaTree,
  FaUserEdit,
} from "react-icons/fa";
import Layout from "../../../layout/default";
import "../../../assets/scss/extend/bootstrap/components/_profilepage.scss";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import { Modal } from "react-bootstrap";

function ProfilePage() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [leftHovered, setLeftHovered] = useState(false);
  const [middleHovered, setMiddleHovered] = useState(false);
  const [rightHovered, setRightHovered] = useState(false);

  const [showLegModal, setShowLegModal] = useState(false);
  const [showUrlModal, setShowUrlModal] = useState(false);
  const [selectedLeg, setSelectedLeg] = useState(null);
  const userId = localStorage.getItem("user_id");
  const [userUrl, setUserUrl] = useState("");

  const handleCloseLegModal = () => setShowLegModal(false);
  const handleCloseUrlModal = () => setShowUrlModal(false);

  const handleShowLegModal = async () => {
    const authToken = localStorage.getItem("authToken");

    try {
      const response = await fetch(`${process.env.REACT_APP_HOST}api/orders/userOrders?user_id=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        debugger;
        // User has at least one order
        setShowLegModal(true);
      } else {
        // No orders found
        Swal.fire({
          icon: 'warning',
          title: 'No Orders Found',
          text: 'You need at least one order to access the referral link.',
        }).then(() => {
          navigate("/shop");
        });
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError("Failed to fetch orders. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
    }
  };

  const handleShowUrlModal = () => setShowUrlModal(true);

  const handleSelectLeg = (selectedLeg) => {
    setSelectedLeg(selectedLeg);
    const newUrl = `${process.env.REACT_APP_API_URL}shop/auths/registration/${userId}?leg=${selectedLeg}`;
    setUserUrl(newUrl);
    handleCloseLegModal();
    handleShowUrlModal();
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(userUrl).then(() => {
      Swal.fire({
        icon: "success",
        title: "URL copied to clipboard!",
        showConfirmButton: false,
        timer: 1500,
      });
      handleCloseUrlModal();
    }).catch(err => {
      Swal.fire({
        icon: "error",
        title: "Failed to copy",
        text: err.message,
      });
    });
  };

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
    setUsername(localStorage.getItem("user_name") || "Guest");

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/shop/auths/login");
  };

  return (
    <Layout title="User Profile">
      <br />
      <br />
      <br />
      <section style={{ backgroundColor: "#eee" }}>
        <MDBContainer className="py-5">
          <MDBRow>
            <MDBCol>
              <MDBBreadcrumb className="bg-light rounded-3 p-3 mb-4">
                <MDBBreadcrumbItem><a href="#">Home</a></MDBBreadcrumbItem>
                <MDBBreadcrumbItem><a href="#">User</a></MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>User Profile</MDBBreadcrumbItem>
              </MDBBreadcrumb>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol lg="4">
              <MDBCard className="mb-4">
                <MDBCardBody className="text-center custom-cardbody-height">
                  <MDBCardImage
                    src="/shop/images/avatar/profile-img.png"
                    thumbnail
                    className="rounded-circle"
                    style={{ width: "150px" }}
                    fluid
                  />
                  <MDBCardText className="username">{username}</MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol lg="8">
              <MDBCard className="mb-4">
                <MDBCardBody>
                  <MDBRow><MDBCol><MDBBtn block onClick={() => navigate("/shop/admin/profile")}><div className="btn-content"><FaUserAlt className="icon" /> My Profile</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/UserDetailSelect")}><div className="btn-content"><FaUserEdit className="icon" /> Update User Details</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/user-address-check")}><div className="btn-content"><FaUserEdit className="icon" /> Update User Details Address</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/change-password")}><div className="btn-content"><FaLock className="icon" /> Change Password</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/User-Comission")}><div className="btn-content"><FaHistory className="icon" /> Commission History</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/orders")}><div className="btn-content"><FaBox className="icon" /> Orders</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/UserTree")}><div className="btn-content"><FaTree className="icon" /> User Tree</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={() => navigate("/shop/auths/terms-and-conditions")}><div className="btn-content"><FaFileAlt className="icon" /> Terms & Conditions</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={handleShowLegModal}><div className="btn-content"><FaGift className="icon" /> Referral Link</div></MDBBtn></MDBCol></MDBRow>
                  <MDBRow className="mt-2"><MDBCol><MDBBtn block onClick={handleLogout}><div className="btn-content"><FaSignOutAlt className="icon" /> Logout</div></MDBBtn></MDBCol></MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>

          {/* Leg Modal */}
          <Modal show={showLegModal} onHide={handleCloseLegModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Select Leg</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex justify-content-center flex-column align-items-center">
                <div className="mb-4" style={{ fontSize: "20px", fontWeight: "bold" }}>
                  User: {username}
                </div>
                <div className="d-flex justify-content-center">
                  <Button
                    variant="outline-primary"
                    onClick={() => handleSelectLeg(0)}
                    style={{
                      margin: '10px',
                      padding: '15px 25px',
                      backgroundColor: leftHovered ? '#007bff' : 'transparent',
                      color: leftHovered ? 'white' : '#007bff',
                      borderColor: '#007bff',
                      transition: 'background-color 0.3s, color 0.3s',
                    }}
                    onMouseEnter={() => setLeftHovered(true)}
                    onMouseLeave={() => setLeftHovered(false)}
                  >
                    Left
                  </Button>
                  <Button
                    variant="outline-primary"
                    onClick={() => handleSelectLeg(1)}
                    style={{
                      margin: '10px',
                      padding: '15px 25px',
                      backgroundColor: middleHovered ? '#007bff' : 'transparent',
                      color: middleHovered ? 'white' : '#007bff',
                      borderColor: '#007bff',
                      transition: 'background-color 0.3s, color 0.3s',
                    }}
                    onMouseEnter={() => setMiddleHovered(true)}
                    onMouseLeave={() => setMiddleHovered(false)}
                  >
                    Middle
                  </Button>
                  <Button
                    variant="outline-primary"
                    onClick={() => handleSelectLeg(2)}
                    style={{
                      margin: '10px',
                      padding: '15px 25px',
                      backgroundColor: rightHovered ? '#007bff' : 'transparent',
                      color: rightHovered ? 'white' : '#007bff',
                      borderColor: '#007bff',
                      transition: 'background-color 0.3s, color 0.3s',
                    }}
                    onMouseEnter={() => setRightHovered(true)}
                    onMouseLeave={() => setRightHovered(false)}
                  >
                    Right
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* URL Modal */}
          <Dialog open={showUrlModal} onClose={handleCloseUrlModal}>
            <DialogTitle>Refer and Earn</DialogTitle>
            <DialogContent>
              <div>
                <div>Your Referral URL:</div>
                <div className="mb-4" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                  {userUrl}
                </div>
                <Button variant="contained" color="primary" onClick={handleCopyToClipboard}>
                  Copy to Clipboard
                </Button>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseUrlModal} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </MDBContainer>
      </section>
    </Layout>
  );
}

export default ProfilePage;
